import { useDocumentTitle } from "@/hooks/use-document-title";

export function CenterPanel({ children, title }: { children: React.ReactNode; title?: string }) {
  useDocumentTitle(title ?? "");
  return (
    <div className="flex-1 overflow-y-auto">
      <div className="mx-auto max-w-5xl px-8 py-6">
        {title && <h1 className="text-2xl font-semibold text-text-primary mb-6">{title}</h1>}
        {children}
      </div>
    </div>
  );
}
